import { configureStore } from '@reduxjs/toolkit';
import authReducer from './reducers/Auth/authSlice';
import mediaLibrarySlice from './reducers/MediaLibrary/mediaLibrarySlice';
import emailSlice from './reducers/Emails/emailSlice';
import usersSlice from './reducers/Users/usersSlice';
import projectSlice from './reducers/Project/projectSlice';
import submissionSlice from './reducers/Submission/submissionSlice';
import leaveSlice from './reducers/Leaves/leaveSlice';
import contactsSlice from './reducers/Contacts/contactsSlice';
import qualitySlice from './reducers/Quality/qualitySlice';
import customerSlice from './reducers/Customer/customerSlice';
import purchaseOrderSlice from './reducers/PurchaseOrder/purchaseOrderSlice';
import paymentTermSLice from './reducers/PaymentTerms/paymentTermSLice';
import notificationSlice from './reducers/Notification/notificationSlice';
import invoiceSlice from './reducers/Invoice/invoice.slice';
import organizationSlice from './reducers/Organization/organizationSlice';
import printSlice from './reducers/Print/printSlice';
import featureSlice from './reducers/Features/featureSlice';
import reminderSubjectSlice from './reducers/ReminderSubject/reminderSubjectSlice';
import reminderPopUpSlice from './reducers/ReminderPopUp/reminderPopUpSlice';
import vendorSlice from './reducers/Vendors/vendorSlice';

export const store = configureStore({
    reducer: {
        auth: authReducer,
        mediaLibrary: mediaLibrarySlice,
        emails: emailSlice,
        users: usersSlice,
        projects: projectSlice,
        submissions: submissionSlice,
        leaves: leaveSlice,
        contacts: contactsSlice,
        customer: customerSlice,
        purchaseOrder: purchaseOrderSlice,
        quality: qualitySlice,
        paymentTerms: paymentTermSLice,
        notification: notificationSlice,
        invoice: invoiceSlice,
        organization: organizationSlice,
        print: printSlice,
        features: featureSlice,
        vendors: vendorSlice,
        reminderSubject: reminderSubjectSlice,
        reminderPopUp: reminderPopUpSlice,
    },
});
